{
  "add_approval_step": "New approval step",
  "all_approvals_required_caption": "Every approver must confirm the request. Best for important decisions needing full review",
  "all_approvals_required_title": "Require all approvals",
  "any_approvals_required_caption": "Request approved after first reviewer confirms. Ideal for routine requests",
  "any_approvals_required_title": "Accept first approval",
  "approval_policy": "Approval policy",
  "approval_process": "Approval process",
  "approval_request": "Approval request",
  "approval_requests": "Approval requests",
  "approval_request_changes_caption": "Changes for {employee} in {process}",
  "approvals_completed": "{completed} of {total} {total, plural, one{approval} other{approvals}} completed",
  "approvals": "Approvals",
  "approvers": "Approvers",
  "category_create_title": "Create category",
  "category_edit_title": "Edit category",
  "category_delete_title": "Delete category",
  "category_delete_description": "Are you sure you want to delete this category? All approval policies in it will be deleted as well",
  "approvals_description": "Set up review processes for requests that need manager confirmation",
  "approve": "Approve",
  "approve_as_admin": "Approve as admin",
  "approve_as_admin_description": "Approve this request at once, bypassing all other reviewers",
  "approve_required": "Approve required",
  "cancel_request": "Cancel request",
  "cancel_request_confirm_description": "Are you sure you want to cancel the request?",
  "changes_for": "Changes for",
  "create_as_admin": "Create as admin",
  "create_as_admin_description": "Create a request, bypassing all approval steps",
  "create_as_employee": "Create as employee",
  "create_as_employee_description": "Create a request, following the assigned approval steps",
  "create_title": "Add new approval flow",
  "default_title": "Standard approval flow",
  "delete_request": "Delete request",
  "edit_approval_step": "Edit approval step",
  "edit_as_admin": "Edit as admin",
  "edit_as_admin_description": "Edit a request, bypassing all approval steps",
  "edit_as_employee": "Edit as employee",
  "edit_as_employee_description": "Edit a request, following the assigned approval steps",
  "edit_substitution_rule": "Edit substitution rule",
  "edit_title": "Edit approval flow",
  "flow_skip_caption": "A step with no approver is skipped. If all steps are skipped, the request is approved automatically",
  "in_category": "In category \"{category}\"",
  "flow_skip_title": "Skip steps with no approver",
  "mandatory_approvals_title": "Approval requirements",
  "new_offer_request_awaiting_approval": "New offer request awaiting your approval",
  "new_hiring_plan_request_awaiting_approval": "New position request awaiting your approval",
  "new_approval_request": "New approval request",
  "my_requests": "My requests",
  "my_requests_empty_title": "No requests yet",
  "my_requests_empty_description": "Requests you submit for approval will appear here.",
  "new_value": "New value",
  "no_approvers_caption": "Request will be approved automatically because there are no approvers assigned to it",
  "parallel_approval_caption": "Simultaneous review by multiple approvers",
  "parallel_approval_title": "Parallel approval",
  "previous_value": "Previous value",
  "reject": "Decline",
  "reject_as_admin": "Decline as admin",
  "reject_as_admin_description": "Decline this request at once, bypassing all other reviewers",
  "request_approved": "Request was approved",
  "request_approved_on_date": "Request was approved on {date}",
  "request_canceled": "Request was canceled",
  "request_created": "Request created",
  "request_details": "Request details",
  "request_deleted": "Request deleted",
  "request_rejected": "Request was declined",
  "request_rejected_on_date": "Request was declined on {date}",
  "requested_changes": "Requested changes",
  "request_status_approved": "Approved",
  "request_status_awaiting": "Pending approval",
  "request_status_canceled": "Canceled",
  "request_status_queued": "Queued",
  "request_status_rejected": "Declined",
  "request_status_skipped": "Skipped",
  "review": "Review",
  "select_create_as": "Select how to create the request",
  "select_edit_as": "Select how to edit the request",
  "select_review_as": "How to review the request",
  "sequence_approval_caption": "Sequential review by multiple people",
  "sequence_approval_title": "Multi-stage approval",
  "settings_description": "Create approval flows for time off and expenses",
  "settings_title": "Approval policies",
  "setup_caption_hiring_plan": "The request will be available if the employee has the Recruiting module enabled",
  "setup_caption_job_offer": "Set up approval rules for job offers",
  "setup_caption_time_off": "Set up approval rules for vacation, sick leave, and other time off requests",
  "step": "Step {step}",
  "any_selected_employee_can_approve": "Any selected employee can approve",
  "multiple_approvers_require_sequence": "Multiple employees in one approval step are only available for sequential approval",
  "steps_caption": "Define who needs to approve employee requests and in what order",
  "steps_title": "Approval steps",
  "substitution_enabled_caption": "Set up a substitution rule to route the request when the approver is on non-working leave",
  "substitution_enabled_title": "Enable approver substitution when absent",
  "substitution_type_caption": "Action when absent",
  "time_off_approvals": "Time off",
  "time_off_categories_caption": "If no types are selected, the policy applies to all time off types",
  "time_off_categories_title": "Time off types",
  "time_off_request": "Time off request",
  "workflow_request": "Flow request",
  "~": "~",
  "comment_your_decision": "Comment your decision"
}
